import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { AnalyticsDevFlagsEffects } from './lib/analytics-dev-flags.effects';
import {
  AnalyticsDevFlagsNamespace,
  AnalyticsDevFlagsReducer,
} from './lib/analytics-dev-flags.store';

export * from './lib/analytics-dev-flags.store';
export * from './lib/analytics-dev-flags.http';

export const analyticsDevFlagsData = [
  provideState(AnalyticsDevFlagsNamespace, AnalyticsDevFlagsReducer),
  provideEffects([AnalyticsDevFlagsEffects]),
];
